export const MOCK_MODULE_EXAM = {
  id: 'mock-module-exam-id',
  title: 'mock-module-exam',
  metadata: {
    qConfigStructureParts: [],
  },
};
